module.exports = __webpack_public_path__ + "media/images/icons/sync-b28ec2de1c508a4bebd3d050af3b2ef4.gif";